/**
 * Created by Adam on 17/08/2016.
 */

(function (angular) {
    'use strict';

    if (!angular) return;

    angular
        .module('autocompleteCitySearch', ['ngMaterial'])
        .directive('mdFocus', ['$timeout', function ($timeout) {
            return {
                restrict: 'A',
                link: function (scope, element, attributes) {
                    $timeout(function () {
                        angular.element(element[0].querySelector("input")).bind("focus", function () {
                            $timeout(function () {
                                scope.$eval(attributes.mdFocus);
                            }, 100);
                        });
                    }, 0);
                }
            };
        }]).directive('mdBlur', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                $timeout(function () {
                    angular.element(element[0].querySelector("input")).bind("blur", function () {
                        $timeout(function () {
                            scope.$eval(attributes.mdBlur);
                        }, 100);
                    });
                }, 0);
            }
        };

    }]).directive('mdShowMoreButton', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {

                element.bind("click", function (e) {
                    scope.$eval(attributes.mdShowMoreButton);
                });
            }
        };

    }]).directive('mdSelectable', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                var liContainer = element.closest('li');
                if (!$parse(attributes.mdSelectable)(scope)) {
                    liContainer.addClass('md-non-selectable');
                }
                else {
                    liContainer.removeClass('md-non-selectable');
                }
            }
        };

    }]).directive('mdBigBox', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                var liContainer = element.closest('li');
                if ($parse(attributes.mdBigBox)(scope)) {
                    liContainer.addClass('md-big-box');
                }
                else {
                    liContainer.removeClass('md-big-box');
                }
            }
        };

    }])
        .controller('autoComplete', ['$log', '$http', '$scope', '$window', '$location', '$q', function autoComplete($log,
                                                                                                                    $http,
                                                                                                                    $scope,
                                                                                                                    $window,
                                                                                                                    $location,
                                                                                                                    $q) {
            var self = this;
            $scope.init = function (homeUrl, currentSearch, placeholder, isLocation, locationKgId, isSticky, showRecentSearch) {
                self.isDisabled = true;
                $scope.homeUrl = homeUrl;
                $scope.searchText = currentSearch || '';
                $scope.placeholderSelector = placeholder;
                $scope.placeholderSelectorLocation = placeholder;
                $scope.pageUrl = $location.absUrl().split('?')[0];    //URL without query parameters
                $scope.isLocation = isLocation;
                self.showRecentSearchSection = showRecentSearch ? showRecentSearch : false;
                self.citySearchElm = document.querySelector('.city-search');
                self.logoElm = document.querySelector('.brand-logo');
                self.navMenuElm = document.querySelector('.mobile-menu');
                self.goButton = angular.element('.city-search .autocompleteBtn');
                //check if empty to disable go button
                if ($scope.searchText === "") {
                    self.goButton.addClass('btn-disable');
                }
                //it mean that we need to take the kg id from the user API call
                if (!locationKgId) {
                    getKgIdFromApi().then(function (data) {
                        $scope.locationKgId = data;
                        $scope.isSticky = isSticky;
                        getExploreKeyFromApi();
                        self.isDisabled = false;
                    });

                }
                else {
                    $scope.locationKgId = locationKgId;
                    $scope.isSticky = isSticky;
                    getExploreKeyFromApi();
                    self.isDisabled = false;
                }
            };

            var cdnPath = "http://cdn.theculturetrip.com/wp-content/themes/theculturetrip/assets/images/autocomplete/";
            var LOCATION_TYPE = 'location',
                ARTICLE_TYPE = 'article',
                GENRE_TYPE = 'genre',
                SEARCH_TYPE = 'search',
                RECENT_SEARCH_TYPE = "recent";

            $scope.symbolDict = {
                'CITY': cdnPath + "city.png",
                'COUNTRY': cdnPath + "country.png",
                'NEIGHBORHOOD': cdnPath + "neighborhood.png",
                'SEARCH': cdnPath + "search.png",
                'RECENT_SEARCH': cdnPath + "recent.png"

            };

            $scope.showMorePressed = {
                'location': false,
                'article': false,
                'genre': false,
                "recent": false
            };

            self.simulateQuery = false;
            self.isDisabled = false;
            self.querySearch = querySearch;
            self.selectedItemChange = chooseAction;
            self.recentSearch = JSON.parse(window.localStorage.getItem("recentSearch"));
            self.recentSearchKeys = JSON.parse(window.localStorage.getItem("recentSearchKeys"));
            $scope.startWrite = false;
            $scope.isFocused = false;
            $scope.noCache = true;
            $scope.showMoreClicked = false;
            $scope.inputEmpty = true;
            self.showMoreNumber = 4;
            // ******************************
            // Internal methods
            // ******************************
            /**
             * Search for repos... use $timeout to simulate
             * remote dataservice call.
             */


            function querySearch(inputPrefix) {
                var shouldShowSearchForFree = true,
                    shouldShowRecentSearch = true,
                    apiCall = "v3/autoComplete?",
                    queryType;

                //This mean that we need to show the user the suggestion depend
                if (inputPrefix.length < 2) {

                    shouldShowSearchForFree = false;
                    //Check if we in page with location ID
                    if ($scope.isLocation) {

                        queryType = "search_result_no_pattern";
                    }
                    else {

                        queryType = "default_location_no_pattern";
                    }
                }
                else {
                    apiCall = "v3/autoComplete?s=" + encodeURIComponent(inputPrefix) + "&";
                    shouldShowRecentSearch = false;

                    if ($scope.isLocation) {

                        queryType = "search_result_with_pattern";
                    }
                    else {

                        queryType = "default_location_with_pattern";
                    }
                }
                var resultArray = [];

                return getAutoCompleteResult(apiCall, $scope.locationKgId, queryType).then(function (response) {
                    resultArray = getRecentSearch(shouldShowRecentSearch);
                    if (response.data !== null && response.data.length > 0) {
                        response.data.forEach(function (section, index) {
                            var sectionType = "";
                            var name = "";
                            if (section.hasOwnProperty("sectionTitle")) {
                                resultArray.push({
                                    name: section.sectionTitle,
                                    nodeType: "sectionTitle",
                                    isLinkType: false,
                                    isTitleType: true,
                                    isArticleType: false,
                                    isShowMoreButtonType: false,
                                    isClickable: false,
                                    isBigBox: false
                                });
                                sectionType = section.sectionType;
                                if (section.hasOwnProperty("name")) {
                                    name = section.name;
                                }
                            }
                            var showMoreButton = false;
                            if (self.showMoreNumber < section.data.length) {
                                showMoreButton = true
                            }
                            section.data.forEach(function (item, index) {
                                var displaySlot = index < 3 || !showMoreButton,
                                    href = "",
                                    image = "",
                                    nodeType = "",
                                    backgroundColor = "#c7b76c",
                                    isLink = true,
                                    isArticle = false,
                                    displayName = item.name,
                                    recentName = item.name;
                                if (item.hasOwnProperty("links")) {
                                    item.links.forEach(function (link) {
                                        if (link.rel === "web_self") {
                                            href = link.href;
                                        }
                                    });
                                }
                                switch (sectionType) {
                                    case "AUTOCOMPLETE_NEIGHBORHOODS":
                                    case "AUTOCOMPLETE_SUGGESTIONS":
                                        if (item.nodeType.toLowerCase() !== 'continent' && item.hasOwnProperty("parent")) {
                                            displayName += ", " + item.parent.name;
                                        }

                                        switch (item.nodeType) {
                                            case "CITY":
                                                image = $scope.symbolDict.CITY;
                                                break;
                                            case "COUNTRY":
                                            case"STATE":
                                                image = $scope.symbolDict.COUNTRY;
                                                break;
                                            case "DISTRICT":
                                                image = $scope.symbolDict.NEIGHBORHOOD;
                                                break;
                                            default:
                                                image = $scope.symbolDict.COUNTRY;
                                                break;
                                        }
                                        nodeType = LOCATION_TYPE;
                                        backgroundColor = "#c7b76c";
                                        isLink = true;
                                        isArticle = false;
                                        recentName = displayName;
                                        break;
                                    case "AUTOCOMPLETE_ARTICLES":
                                        if (item.links.length > 0) {
                                            image = "https://cdn.theculturetrip.com/images/default_location.jpg";
                                            if (item.imageResource.links.length > 0) {
                                                image = item.imageResource.links[0].href;
                                            }
                                        }
                                        nodeType = ARTICLE_TYPE;
                                        backgroundColor = "";
                                        isLink = false;
                                        isArticle = true;
                                        break;
                                    case "AUTOCOMPLETE_EXPLORE":
                                        var exploreKeys = "";
                                        if (item.links[0].href.split("exploreKeys=")[1] !== null) {
                                            exploreKeys = item.links[0].href.split("exploreKeys=")[1];
                                        }
                                        image = $scope.symbolDict[exploreKeys];
                                        nodeType = GENRE_TYPE;
                                        item.nodeType = GENRE_TYPE;
                                        backgroundColor = "#6071ff";
                                        isLink = true;
                                        isArticle = false;
                                        recentName = name ? recentName + " in " + name : recentName;
                                        break;

                                }
                                //determine if to show the show more button (it depend if we in index 4 and if the show more button not press for the specific type press)
                                if (showMoreButton && index === self.showMoreNumber - 1 && !$scope.showMorePressed[nodeType]) {
                                    resultArray.push({
                                        name: "Show More",
                                        nodeType: nodeType,
                                        isLinkType: false,
                                        isTitleType: false,
                                        isArticleType: false,
                                        isShowMoreButtonType: true,
                                        isClickable: true,
                                        isBigBox: false
                                    });
                                }
                                if ($scope.showMorePressed[nodeType] || displaySlot) {

                                    resultArray.push({
                                        name: displayName,
                                        recentSearchName: recentName,
                                        nodeType: item.nodeType.toLowerCase(),
                                        backgroundColor: backgroundColor,
                                        link: href,
                                        imageSrc: image,
                                        isLinkType: isLink,
                                        isTitleType: false,
                                        isArticleType: isArticle,
                                        isShowMoreButtonType: false,
                                        isClickable: true,
                                        isBigBox: isArticle

                                    });
                                }

                            })
                        });
                    }
                    else {
                        if (shouldShowSearchForFree) {
                            //only put free search option if input's length is more than two characters
                            resultArray = [{
                                name: inputPrefix,
                                nodeType: SEARCH_TYPE,
                                imageSrc: $scope.symbolDict.SEARCH,
                                backgroundColor: "#3b3b3b",
                                isLinkType: true,
                                isTitleType: false,
                                isArticleType: false,
                                isShowMoreButtonType: false,
                                isClickable: true,
                                isBigBox: false
                            }];
                        }
                    }

                    for (var key in $scope.showMorePressed) {
                        if ($scope.showMorePressed.hasOwnProperty(key)) {
                            $scope.showMorePressed[key] = false;
                        }
                    }
                    if ($scope.showMoreClicked) {
                        $scope.showMoreClicked = false;
                    }
                    //The timeout is to let md-virtual-repeat-container to get the new result array and to create the list items
                    setTimeout(function () {
                        $scope.$broadcast('getResultFromApi')
                    }, 100);

                    return resultArray;
                });

            }

            $scope.$on('getResultFromApi', function () {
                //This section is for changing the height when the height of the virtual repeat is less then 512px
                var ulHeight = 0;
                angular.forEach(angular.element('.md-virtual-repeat-offsetter ul.md-autocomplete-suggestions li'), function (value) {
                    ulHeight += angular.element(value).height();
                });
                angular.forEach(angular.element('md-virtual-repeat-container'), function (value) {
                    if (angular.element('li', value).length) {
                        if (ulHeight <= 512) {
                            angular.element(value).height(ulHeight);
                        }
                        else if (jQuery('li', value).height() < 512) {
                            angular.element(value).height(512);
                        }
                    }
                });
            });
            function chooseAction(item) {
                if (item !== null && item.hasOwnProperty("nodeType")) {
                    var navBarSticky = ($scope.isSticky && $window.scrollY > 0) ? "true" : "false";
                    var trackEvent = "{sticky:" + navBarSticky + ", choice:" + $scope.searchText + ",type:" + item.nodeType + ",beforeType:" + $scope.inputEmpty + "}";
                    if (item.nodeType === SEARCH_TYPE) {
                        trackCTA('top_nav_auto_complete_choose', trackEvent);
                        trackConversion('top_nav_auto_complete_choose', location.href, trackEvent);
                        $scope.searchSelector(item.name);
                    }
                    else if (item.nodeType === RECENT_SEARCH_TYPE) {
                        trackCTA('top_nav_auto_complete_choose', trackEvent);
                        trackConversion('top_nav_auto_complete_choose', location.href, trackEvent);
                        $window.location.href = item.link;
                    }
                    else if (item.nodeType !== "sectionTitle") {
                        insertToLocalStorage(item.recentSearchName, $scope.homeUrl + item.link);
                        trackCTA('top_nav_auto_complete_choose', trackEvent);
                        trackConversion('top_nav_auto_complete_choose', location.href, trackEvent);
                        $window.location.href = $scope.homeUrl + item.link;

                    }
                }

            }


            function getAutoCompleteResult(apiCall, locationKgId, queryType) {
                return $http.get(window.TCTServer.api + apiCall + "locationKGID=" + locationKgId + '&queryType=' + queryType);
            }

            function getExploreKeyFromApi() {
                $http.get(window.TCTServer.api + "v2/articles/explore-categories").then(function (response) {

                    if (response.data !== null) {
                        response.data.forEach(function (key, index) {
                            $scope.symbolDict[key.exploreKey] = cdnPath + key.exploreKey + ".png";
                        })
                    }
                });
            }

            function getKgIdFromApi() {
                var data = "";
                var deferred = $q.defer();

                $http.get(window.TCTServer.api + "v1/locations/user")
                    .then(function (response) {
                        if (response.data && response.data.kgID) {
                            data = response.data.kgID;
                        }
                        else {
                            data = "";
                        }
                        deferred.resolve(data);
                    }, function (response) {
                        data = "";
                        deferred.resolve(data);
                    });

                return deferred.promise;
            }

            function isLocalStorageNameSupported() {
                var testKey = 'test', storage = window.localStorage;
                try {
                    storage.setItem(testKey, '1');
                    storage.removeItem(testKey);
                    return true;
                } catch (error) {
                    return false;
                }
            }

            function insertToLocalStorage(searchResult, url) {
                if (isLocalStorageNameSupported()) {
                    if (self.recentSearch) {
                        if (self.recentSearchKeys.indexOf(searchResult) === -1) {
                            self.recentSearch.unshift({
                                "search": searchResult,
                                "url": url
                            });
                            self.recentSearchKeys.push(searchResult);
                        }
                    }
                    else {
                        self.recentSearch = [{
                            "search": searchResult,
                            "url": url
                        }];
                        self.recentSearchKeys = [searchResult];
                    }
                    window.localStorage.setItem("recentSearch", JSON.stringify(self.recentSearch));
                    window.localStorage.setItem("recentSearchKeys", JSON.stringify(self.recentSearchKeys));
                }
            }

            function getRecentSearch(shouldShowRecentSearch) {

                var recentSearchAttay = [],
                    lengthOfResults = self.recentSearch ? self.recentSearch.length : 0,
                    showMoreButton = lengthOfResults > 2;


                if (!self.showRecentSearchSection || (self.showRecentSearchSection && !shouldShowRecentSearch)) {
                    return recentSearchAttay;
                }
                //It mean there is result so need to create title section
                if (lengthOfResults) {
                    recentSearchAttay.push({
                        name: "Recently Explored",
                        nodeType: "sectionTitle",
                        isLinkType: false,
                        isTitleType: true,
                        isArticleType: false,
                        isShowMoreButtonType: false,
                        isClickable: false,
                        isBigBox: false
                    });
                }
                if (self.recentSearch) {
                    self.recentSearch.forEach(function (item, index) {

                        var displaySlot = index < 2,
                            href = item.url,
                            image = $scope.symbolDict.RECENT_SEARCH,
                            nodeType = RECENT_SEARCH_TYPE,
                            backgroundColor = "#d7d7d7",
                            displayName = item.search;

                        if (showMoreButton && index === 2 && !$scope.showMorePressed[nodeType]) {
                            recentSearchAttay.push({
                                name: "Show More",
                                nodeType: nodeType,
                                isLinkType: false,
                                isTitleType: false,
                                isArticleType: false,
                                isShowMoreButtonType: true,
                                isClickable: true,
                                isBigBox: false
                            });
                        }
                        if ($scope.showMorePressed[nodeType] || displaySlot) {
                            recentSearchAttay.push({
                                name: displayName,
                                nodeType: nodeType,
                                backgroundColor: backgroundColor,
                                link: href,
                                imageSrc: image,
                                isLinkType: true,
                                isTitleType: false,
                                isArticleType: false,
                                isShowMoreButtonType: false,
                                isClickable: true,
                                isBigBox: false
                            });
                        }
                    });
                }
                return recentSearchAttay;

            }


            $scope.searchSelector = function (inputToSearch) {
                if (inputToSearch !== "") {
                    var searchUrl = $scope.homeUrl + '?s=' + encodeURIComponent(inputToSearch);
                    insertToLocalStorage(inputToSearch, searchUrl);
                    $window.location.assign(searchUrl);
                }
            };

            $scope.checkIfEnterPressed = function (keyEvent, isButton) {
                if (keyEvent.which === 13 && $scope.searchText != '' || keyEvent == "button") {
                    var navBarSticky = ($scope.isSticky && $window.scrollY > 0) ? "true" : "false",
                        trackEvent = "{sticky:" + navBarSticky + ",input:" + $scope.searchText + ",type:search" + ",beforeType:" + $scope.inputEmpty + "}";
                    if (isButton !== undefined && isButton) {
                        trackEvent = "{sticky:" + navBarSticky + ",input:" + $scope.searchText + ",type:searchButton" + ",beforeType:" + $scope.inputEmpty + "}";
                    }
                    trackCTA('top_nav_auto_complete_choose', trackEvent);
                    trackConversion('top_nav_auto_complete_choose', location.href, trackEvent);
                    $scope.searchSelector($scope.searchText);
                }
            };

            $scope.trackOnFocus = function () {
                jQuery("html").css({"overflow": "hidden"});
                jQuery("body").css({"overflow": "hidden"});
                $scope.isFocused = true;
                $scope.placeholderSelector = "Explore your world";
                if (!$scope.showMoreClicked) {
                    var navBarSticky = ($scope.isSticky && $window.scrollY > 0) ? "true" : "false";
                    var trackEvent = "{sticky:" + navBarSticky + ",beforeType:" + $scope.inputEmpty + "}";
                    trackCTA('top_nav_auto_complete_focus', trackEvent);
                }
                else {
                    var input =angular.element('md-autocomplete input');
                    var inScroll= angular.element('body');
                    if (input.length>0 && inScroll.hasClass("in-scroll")){
                        input.blur();
                    }
                }
                $scope.startWrite = true;

            };

            $scope.onBlur = function () {
                jQuery("html").css({"overflow": ""});
                jQuery("body").css({"overflow": ""});
                $scope.isFocused = false;
                $scope.placeholderSelector = $scope.placeholderSelectorLocation;
                // trackCTA('top_nav_auto_complete_no_action',$scope.searchText);


            };

            $scope.clickShowMore = function (buttonType) {
                var navBarSticky = ($scope.isSticky && $window.scrollY > 0) ? "true" : "false";
                var trackEvent = "{sticky:" + navBarSticky + ",beforeType:" + $scope.inputEmpty + "}";
                trackCTA('top_nav_auto_complete_click_show_more', trackEvent);
                $scope.showMoreClicked = true;
                $scope.showMorePressed[buttonType] = true;
                if ($scope.$$childHead.hasOwnProperty("$mdAutocompleteCtrl")) {
                    $scope.$$childHead.$mdAutocompleteCtrl.listLeave();
                }
            };

            $scope.textOnChange = function () {
                $scope.inputEmpty = $scope.searchText === "";

                if ($scope.inputEmpty) {
                    if (!self.goButton.hasClass('btn-disable'))
                        self.goButton.addClass('btn-disable');
                }
                else if (self.goButton.hasClass('btn-disable')) {
                    self.goButton.removeClass('btn-disable');
                }

                for (var key in $scope.showMorePressed) {
                    if ($scope.showMorePressed.hasOwnProperty(key)) {
                        $scope.showMorePressed[key] = false;
                    }
                }
                if ($scope.startWrite) {
                    var cookieName = "TCT_auto_complete_first_time_type",
                        sendEvent = getCookie(cookieName);
                    if (!sendEvent) {
                        var navBarSticky = ($scope.isSticky && $window.scrollY > 0) ? "true" : "false";
                        var trackEvent = "{sticky:" + navBarSticky + "}";
                        trackCTA('top_nav_auto_complete_start_type', trackEvent);
                        setCookie('TCT_auto_complete_first_time_type', true, 1);
                    }
                    $scope.startWrite = false;
                }
            };
        }]);

    angular.element(document).ready(function () {
        var elements = document.getElementsByClassName('city-search');

        for (var i = 0; i < elements.length; i++) {
            var element = elements[i],
                wrapped = angular.element(element);

            angular.bootstrap(wrapped, ['autocompleteCitySearch']);
        }
    });

})(window['angular']);